import React from "react";
import { Alert, AlertDescription } from "../components/ui/alert";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Textarea } from "../components/ui/textarea";

import { useState } from "react";
import { useBaseOwnerId, useModelCreate } from "@rhino-project/core/hooks";

export default function Contact() {
    const [name, setName] = useState("");
    const [topic, setTopic] = useState("navigator");
    const [message, setMessage] = useState("");
    const [sent, setSent] = useState(false);
    const organizationId = useBaseOwnerId();
    const { mutate: createSupportRequest, isPending, error } = useModelCreate("support_request" as any);
  return (
   <div className="w-full min-w-0 overflow-x-hidden">
      <div className="flex w-full min-w-0 flex-col gap-6">
          <section className="space-y-4">
      <h1 className="text-2xl font-semibold">Contact & Support</h1>
      <Card>
      <CardHeader><CardTitle>Submit a support request</CardTitle></CardHeader>
      <CardContent className="space-y-4">
      <div className="space-y-2"><Label htmlFor="name">Name</Label><Input id="name" value={name} onChange={(event) => setName(event.target.value)} /></div>
      <div className="space-y-2"><Label htmlFor="topic">Topic</Label><Select value={topic} onValueChange={setTopic}><SelectTrigger id="topic"><SelectValue /></SelectTrigger><SelectContent className="bg-popover text-popover-foreground"><SelectItem value="navigator">Navigator assistance</SelectItem><SelectItem value="technical">Technical support</SelectItem><SelectItem value="partnership">Partnership enquiries</SelectItem></SelectContent></Select></div>
      <div className="space-y-2"><Label htmlFor="message">Message</Label><Textarea id="message" rows={4} value={message} onChange={(event) => setMessage(event.target.value)} /></div>
      <Button type="button" disabled={!name || !message || isPending} onClick={() => createSupportRequest({ name, topic, message, organization_id: Number.isFinite(organizationId) ? organizationId : undefined } as any, { onSuccess: () => setSent(true) })}>{isPending ? "Sending..." : "Send request"}</Button>
      {sent && <p className="text-sm text-primary">Thanks, your request has been queued.</p>}
      {error && <p className="text-sm text-destructive">Unable to queue request. Please try again.</p>}
      </CardContent>
      </Card>
      </section>
  <section>
      <Card>
      <CardContent className="space-y-3 p-4">
      {[
      "Navigator assistance",
      "Technical support",
      "Partnership enquiries",
      ].map((channel) => (
      <Alert key={channel}><Badge className="mr-2" variant="secondary">Channel</Badge><AlertDescription className="inline">{channel}</AlertDescription></Alert>
      ))}
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}